import React, { useEffect, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { Context } from "../../index";
import Card from "../../shared/ui/card/Card";
import Loader from "../../shared/ui/loader/Loader";
import { ROLES } from "../../utils/roles";

interface PlantListProps {
  onPlantClick: (plantId: number, companyId: number) => void;
  onEditPlant: (plantId: number) => void;
}

const PlantListBase = observer(
  ({ onPlantClick, onEditPlant }: PlantListProps) => {
    const { store } = useContext(Context);

    // Загрузка данных — как и раньше
    useEffect(() => {
      const { company, user } = store;
      const roleId = user?.role;

      if (roleId === ROLES.root) {
        store.getAllPlants();
      } else if (roleId === ROLES.org_oper && company?.id) {
        store.getPlants(company.id);
      }
      // plant_oper — ничего не загружает
    }, [store.company?.id, store.user?.role]);

    // Чтение из стора и фильтрация
    const filteredPlants = useMemo(() => {
      let list = store.plants;
      if (store.company?.id) {
        list = list.filter((plant) => plant.company_id === store.company.id);
      }
      // Используем slice().sort() для безопасной сортировки
      return list.slice().sort((a, b) => a.id - b.id);
    }, [store.plants, store.company?.id]);

    // Показываем загрузчик, если растения загружаются
    if (store.isPlantsLoading) {
      return (
        <div className="loader">
          <Loader text="Загрузка объектов..." />
        </div>
      );
    }

    return (
      <div className="plantEl">
        {filteredPlants.map((plant) => (
          <Card
            key={plant.id}
            plant={plant}
            description={plant.description}
            onClick={onPlantClick}
            onEditClick={onEditPlant}
          />
        ))}
      </div>
    );
  },
);

export const PlantList = PlantListBase;
